import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import {
  ContentTranslationSponsor,
  SanityExternalCollaborator,
  SanityLicence
} from "../../model/common";
import BlockContent from "../BlockContent/BlockContent";
import ExternalCollaboratorCredit from "../ExternalCollaboratorCredit/ExternalCollaboratorCredit";
import styles from "./ContentFooter.module.scss";
import Text from "../Text/Text";
import InfoIcon from "../../icons/InfoIcon";
import Link from "../Link/Link";

interface ContentFooterProps {
  accessibility?: boolean;
  licence?: SanityLicence;
  externalCollaborator?: SanityExternalCollaborator;
  translationSponsors?: ContentTranslationSponsor[];
}

/**
 * Suitable for the main content card in a page.
 */
const ContentFooter = ({
  accessibility,
  externalCollaborator,
  licence,
  translationSponsors
}: ContentFooterProps) => {
  const language = useLanguage();
  const sponsor = translationSponsors?.find(
    s => s.languages.indexOf(language) !== -1
  )?.sponsor;
  return (
    <footer className={styles.root}>
      {accessibility && (
        <div className={styles.accessibility}>
          <InfoIcon />
          <Text variant="defaultLight">
            <strong>Adapting for accessibility:</strong> explore our{" "}
            <Link to="/accessibility">Accessibility support</Link> for tips for
            making the micro:bit more accessible to students with disabilities
            or other access needs.
          </Text>
        </div>
      )}
      {externalCollaborator && (
        <ExternalCollaboratorCredit
          size="lg"
          textVariant="default"
          className={styles.externalCollaborator}
          sponsor={externalCollaborator}
        />
      )}
      {(accessibility || licence || sponsor) && (
        <div className={styles.licenceSponsor}>
          {licence && (
            <BlockContent
              bodyVariant="default"
              className={styles.credit}
              content={licence._rawText}
            />
          )}
          {sponsor && (
            <ExternalCollaboratorCredit
              size="lg"
              className={styles.translation}
              sponsor={sponsor}
            />
          )}
        </div>
      )}
    </footer>
  );
};

export default ContentFooter;
